const prefix = '/hospital/drug/';
const route = [
  {
    path: `${prefix}drugstore`,
    name: 'drugSelects',
    component: () => import(/* webpackPrefetchPlaceHolder */ './drugstore'),
    auth: true,
    exact: true,
    // realAuth: true,
    title: '云药房',
  },
];

export default route;
